__turbopack_context__.v({
  "box": "dBGoJa_box",
  "list": "dBGoJa_list",
});
